export default "__VITE_ASSET__204b9869__"